<template>
	<el-dialog title="修改运单" v-model="isEdit" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container scroll-view" style="max-height: 600px; overflow: auto">
			<p class="platTitle">装货信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>托运商</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorShipper" placeholder="请选择所属客商" @change="ProviderTYListChange">
								<el-option v-for="item in ProviderTYList" :key="item.cocId" :label="item.cocName"
									:value="item.cocId" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>贸易商:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorSupplier" placeholder="请选择所属客商">
								<el-option v-for="item in ProviderMYList" :key="item.cocId" :label="item.cocName"
									:value="item.cocId" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>计划装货时间</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="lorLoadpTime" type="datetime" :clearable="false"
								placeholder="请选择计划装货时间" @change="getlorLoadpTime">
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>计划装货吨位（吨）:</span>
						</div>
						<el-input v-model="lorLoadpWeight" class="platItemRigth" placeholder="请输入" type="number"/>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>装货站点:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorLoadWhid" placeholder="请选择" @change="siteLoadChange">
								<el-option v-for="(item, index) in loadsiteList" :key="index" :label="item.whName"
									:value="item.whId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>装货地地址:</span>
						</div>
						<el-input v-model="lorLoadAddr" class="platItemRigth" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>承运车辆:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorVehicleId" placeholder="请选择" @change="vehicleHeadChange">
								<el-option v-for="(item, index) in vehHeadList" :key="index" :label="item.vehHeadNo"
									:value="item.vehicleId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>货品</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorGoods" placeholder="请选择货品">
								<el-option label="LNG" :value="1" />
								<el-option label="CNG" :value="2" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>主驾司机:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorMdriveId" placeholder="请选择" @change="vehicleMUserChange">
								<el-option v-for="(item, index) in driList" :key="item.driUserId" :label="item.driName"
									:value="item.driUserId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>押运员:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="lorYayunId" placeholder="请选择" @change="vehicleYUserChange">
								<el-option v-for="(item, index) in yyList" :key="item.yyUserId" :label="item.yyName"
									:value="item.yyUserId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>驾驶员电话:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-input v-model="vehicleMUserPhone" placeholder="请输入" readonly />
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>押运员电话:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-input v-model="vehicleYUserPhone" placeholder="请输入" readonly />
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem" v-if="permissionItem.editfee">
						<div class="flex flex-y-center platItemLeft">
							<span>运费里程:</span>
						</div>
						<el-input v-model="lorFixedMilage" class="platItemRigth" placeholder="请输入" type="number" />
					</div>
					<div class="w50 flex flex-y-center platItem" v-if="permissionItem.editfee">
						<div class="flex flex-y-center platItemLeft">
							<span>运费单价:</span>
						</div>
						<el-input v-model="lorFixedPrice" class="platItemRigth" placeholder="请输入" type="number" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注:</span>
						</div>
						<el-input v-model="lorRemark" class="platItemRigth" placeholder="请输入" />
					</div>
				</div>
			</div>

			<p class="platTitle">卸货信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>卸货站点:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="unloadList[0].lorlEndWhid" placeholder="请选择"
								@change="siteUnloadChange(0,unloadList[0].lorlEndWhid)">
								<el-option v-for="(item, index) in unloadsiteList" :key="index" :label="item.whName"
									:value="item.whId">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>卸货地地址:</span>
						</div>
						<el-input v-model="unloadList[0].lorlEndAddr" class="platItemRigth" readonly />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>计划到站时间</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-date-picker v-model="unloadList[0].lorlUnlpTime" type="datetime" :clearable="false"
								placeholder="请选择计划到站时间" @change="getlorlUnlpTime(0,unloadList[0].lorlUnlpTime)">
							</el-date-picker>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>计划卸货吨位（吨）:</span>
						</div>
						<el-input v-model="unloadList[0].lorlUnlpWeight" class="platItemRigth" placeholder="请输入" type="number"/>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>收货人:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-input v-model="unloadList[0].lorlEndContact" placeholder="请输入" />
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>收货人电话:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-input v-model="unloadList[0].lorlEndPhone" placeholder="请输入" />
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备用联系人:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-input v-model="unloadList[0].lorlEndContact2" placeholder="请输入" />
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备用联系电话:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-input v-model="unloadList[0].lorlEndPhone2" placeholder="请输入" />
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注:</span>
						</div>
						<el-input v-model="unloadList[0].lorlUnlRemark" class="platItemRigth" placeholder="请输入" />
					</div>
				</div>
			</div>
			<!-- <p class="platTitle">卸货地</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="jzWrap">
						<div class="jzBox flex flex-y-center" v-for="(item, index) in serviceSpecDOList" :key="index">
							<div class="flex flex-y-center flex-wrap jzBoxLeft"
								style="padding-right: 20px;padding-left: 20px;">
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>卸货顺序:</span>
									</div>
									<el-input v-model="orgName" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>卸货地名称:</span>
									</div>
									<el-input v-model="orgName" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>卸货地地址:</span>
									</div>
									<el-input v-model="orgName" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>收货人:</span>
									</div>
									<el-input v-model="orgName" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>收货电话:</span>
									</div>
									<el-input v-model="orgName" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>计划到站时间:</span>
									</div>
									<el-input v-model="orgName" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>计划卸货吨位:</span>
									</div>
									<el-input v-model="orgName" class="platItemRigth" placeholder="请输入" />
								</div>
								<div class="w50 flex flex-y-center platItem">
									<div class="flex flex-y-center platItemLeft">
										<span class="input-fail">*</span>
										<span>备注:</span>
									</div>
									<el-input v-model="orgName" class="platItemRigth" placeholder="请输入" />
								</div>

							</div>
							<div class="jzBoxRight flex flex-y-center" v-if="pageType != 'detail'">
								<img src="@/assets/images/add-goods-icon.png" @click="addJy()" alt="" srcset="" />
								<img src="@/assets/images/del-goods-icon.png" @click="delJy(index)" alt="" srcset="" />
							</div>
						</div>
					</div>
				</div>
			</div> -->

			<span class="footer_btn_warp">
				<template v-if="pageType != 'detail'">
					<!-- <span class="btn btn-outline-default" v-on:click="closeModal()">取消</span>
					<span class="btn bg-default ml-50" v-on:click="submit()">确定</span> -->
					<div class="cancle_btn" v-on:click="closeModal()">取消</div>
					<div class="confirm_btn" v-on:click="submit()">确定</div>
				</template>
			</span>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		parseTime,
		formatDatetime,
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";

	import "@riophae/vue-treeselect/dist/vue-treeselect.css";
	import * as imageConversion from "image-conversion";
	export default defineComponent({
		name: "Add",
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "waybillManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "waybillManage:add") {
						data.permissionItem.add = true;
					}
					if (el == "waybillManage:edit") {
						data.permissionItem.edit = true;
					}
					if (el == "waybillManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "waybillManage:audit") {
						data.permissionItem.audit = true;
					}
					if (el == "waybillManage:fee") {
						data.permissionItem.fee = true;
					}
					if (el == "waybillManage:editfee") {
						data.permissionItem.editfee = true;
					}
				});
				
				nextTick(() => {
					getProviderTYList(); //获取托运商
					getProviderMYList(); //获取贸易商
					getVehicleList(); //获取承运车辆
					getDirList(); //获取主驾司机
					getYyList(); //获取押运员
				});
			});
			const data = reactive({
				isEdit: false,
				searchWord: "",
				ProviderTYList: [], //所属托运商
				ProviderMYList: [], //所属贸易商
				vehHeadList: [],
				vehicleMUserPhone: "",
				vehicleYUserPhone: "",
				driList: [],
				yyList: [],
				loadsiteList: [],
				unloadsiteList: [],

				lorId: "",
				lorType: "0",
				lorCarrier: "TOP", //承运商ID
				lorCarrierType: "1",
				lorShipper: "", //托运商ID 
				lorShipperType: "0",
				lorSupplier: "", //供应商ID
				lorSupplierType: "0",
				lorGoods: "",
				lorLoadType: "0",
				lorLoadWhid: null, //装货站点ID
				lorLoadName: "",
				lorLoadAddr: "",
				lorLoadLnglat: "",
				lorLoadContact: "",
				lorLoadPhone: "",
				lorLoadContact2: "",
				lorLoadPhone2: "",
				lorLoadRemark: "",
				lorLoadpTime: "",
				lorLoadpWeight: "",
				lorVehicleId: null, //运力车辆
				lorVehHeadId: null,
				lorVehHeadNo: "",
				lorVehTailId: null,
				lorVehTailNo: "",
				lorMdriveId: null, //主驾
				lorSdriveId: null, //副驾
				lorYayunId: null, //押运员
				lorRemark: "",
				lorFixedMilage: "", //运费里程
				lorFixedPrice: "", //运费单价
				unloadList: [{
					lorlId: "",
					lorlSort: 1,
					lorlEndWhid: null, //卸货站点ID
					lorlEndName: "",
					lorlEndAddr: "",
					lorlEndPcode: "450000",
					lorlEndCcode: "451200",
					lorlEndAcode: "451227",
					lorlEndLnglat: "",
					lorlEndContact: "",
					lorlEndPhone: "",
					lorlEndContact2: "",
					lorlEndPhone2: "",
					lorlUnlpTime: "",
					lorlUnlpWeight: "",
					lorlUnlRemark: ""
				}],

				serviceSpecDOList: [{
						specName: "123"
					},
					{
						specName: "5454"
					},

				],
				
				permissionItem: {
					list: false,
					add: false,
					edit: false,
					del: false,
					audit: false,
					fee: false,
					editfee: false,
				},
			});
			//重置数据
			const init = async (id) => {
				data.isEdit = true;
				data.searchWord = "";
				// data.ProviderTYList = []; //所属托运商
				// data.ProviderMYList = []; //所属贸易商
				// data.vehHeadList = [];
				// data.driList = [];
				// data.yyList = [];
				// data.siteList = [];



				data.lorId = id;
				let params = {
					lorId: id,
				};
				const r = await proxy.$http.get(apiObj.ordDetail, params);
				if (r) {
					data.lorType = r.orderInfo.lorType;
					data.lorCarrier = r.orderInfo.lorCarrier;
					data.lorCarrierType = r.orderInfo.lorCarrierType;
					data.lorShipper = r.orderInfo.lorShipper;
					getloadSiteList(r.orderInfo.lorShipper);
					getunloadSiteList(r.orderInfo.lorShipper);
					data.lorShipperType = r.orderInfo.lorShipperType;
					data.lorSupplier = r.orderInfo.lorSupplier;
					data.lorSupplierType = r.orderInfo.lorSupplierType;
					data.lorGoods = r.orderInfo.lorGoods;
					data.lorLoadType = r.orderInfo.lorLoadType;
					data.lorLoadWhid = r.orderInfo.lorLoadWhid;
					data.lorLoadName = r.orderInfo.lorLoadName;
					data.lorLoadAddr = r.orderInfo.lorLoadAddr;
					data.lorLoadLnglat = r.orderInfo.lorLoadLnglat;
					data.lorLoadContact = r.orderInfo.lorLoadContact;
					data.lorLoadPhone = r.orderInfo.lorLoadPhone;
					data.lorLoadContact2 = r.orderInfo.lorLoadContact2;
					data.lorLoadPhone2 = r.orderInfo.lorLoadPhone2;
					data.lorLoadRemark = r.orderInfo.lorLoadRemark;
					data.lorLoadpTime = r.orderInfo.lorLoadpTime;
					data.lorLoadpWeight = r.orderInfo.lorLoadpWeight;
					data.lorVehicleId = r.orderInfo.lorVehicleId;
					data.lorVehHeadId = r.orderInfo.lorVehHeadId;
					data.lorVehHeadNo = r.orderInfo.lorVehHeadNo;
					data.lorVehTailId = r.orderInfo.lorVehTailId;
					data.lorVehTailNo = r.orderInfo.lorVehTailNo;
					data.lorMdriveId = r.orderInfo.lorMdriveId;
					data.lorSdriveId = r.orderInfo.lorSdriveId;
					data.lorYayunId = r.orderInfo.lorYayunId;
					data.vehicleMUserPhone = r.orderInfo.odrMDirPhone;
					data.vehicleYUserPhone = r.orderInfo.odrYayunPhone;
					data.lorRemark = r.orderInfo.lorRemark;
					data.lorFixedMilage = r.orderInfo.lorFixedMilage;
					data.lorFixedPrice = r.orderInfo.lorFixedPrice;
					data.unloadList = [];
					r.orderInfo.unloadList.forEach((el) => {
						data.unloadList.push({
							lorlId: el.lorlId,
							lorlSort: el.lorlSort,
							lorlEndWhid: el.lorlEndWhid, //卸货站点ID
							lorlEndName: el.lorlEndName,
							lorlEndAddr: el.lorlEndAddr,
							lorlEndPcode: "450000",
							lorlEndCcode: "451200",
							lorlEndAcode: "451227",
							lorlEndLnglat: el.lorlEndLnglat,
							lorlEndContact: el.lorlEndContact,
							lorlEndPhone: el.lorlEndPhone,
							lorlEndContact2: el.lorlEndContact2,
							lorlEndPhone2: el.lorlEndPhone2,
							lorlUnlpTime: el.lorlUnlpTime,
							lorlUnlpWeight: el.lorlUnlpWeight,
							lorlUnlRemark: el.lorlUnlRemark
						});
					});
				}

			};

			// 上传图片
			const handleAddUploadChange = async (file) => {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					imageConversion.compress(file.raw, 0.6).then((res) => {
						imgFileToBase64({
							raw: res
						}, (imageUrl) => {
							data.dataItem.userHeadImg = imageUrl;
						});
					});
				} else {
					imgFileToBase64(file, (imageUrl) => {
						data.dataItem.userHeadImg = imageUrl;
					});
				}
			};
			const dialogClosedHandle = () => {
				data.isEdit = false;
			};
			const closeModal = () => {
				data.isEdit = false;
			};
			const submit = async () => {
				if (data.lorShipper === "" || data.lorShipper == null) {
					proxy.$message.error("请选择所属客商");
					return;
				}
				if (data.lorGoods === "" || data.lorGoods == null) {
					proxy.$message.error("请选择货品");
					return;
				}
				if (data.lorLoadpTime == "" || data.lorLoadpTime == null) {
					proxy.$message.error("请选择计划装货时间");
					return;
				}
				if (data.lorLoadpWeight == "" || data.lorLoadpWeight == null) {
					proxy.$message.error("请填写计划装货吨位");
					return;
				}
				if (Number(data.lorLoadpWeight)>23) {
					proxy.$message.error("请输入计划装货吨位小于23以内的数字");
					return;
				}
				if (data.lorLoadWhid === "" || data.lorLoadWhid == null) {
					proxy.$message.error("请选择装货站点");
					return;
				}
				if (data.lorVehicleId === "" || data.lorVehicleId == null) {
					proxy.$message.error("请选择承运车辆");
					return;
				}
				if (data.lorMdriveId === "" || data.lorMdriveId == null) {
					proxy.$message.error("请选择主驾司机");
					return;
				}
				if (data.lorYayunId === "" || data.lorYayunId == null) {
					proxy.$message.error("请选择押运员");
					return;
				}
				// if (data.lorFixedMilage == "" || data.lorFixedMilage == null) {
				// 	proxy.$message.error("请填写运费里程");
				// 	return;
				// }
				// if (data.lorFixedPrice == "" || data.lorFixedPrice == null) {
				// 	proxy.$message.error("请填写运费单价");
				// 	return;
				// }
				if (data.unloadList[0].lorlEndWhid === "" || data.unloadList[0].lorlEndWhid == null) {
					proxy.$message.error("请选择卸货站点");
					return;
				}
				if (data.unloadList[0].lorlUnlpTime == "" || data.unloadList[0].lorlUnlpTime == null) {
					proxy.$message.error("请选择计划到站时间");
					return;
				}
				if (data.unloadList[0].lorlUnlpWeight == "" || data.unloadList[0].lorlUnlpWeight == null) {
					proxy.$message.error("请填写计划卸货吨位");
					return;
				}
				if (Number(data.unloadList[0].lorlUnlpWeight)>23) {
					proxy.$message.error("请输入计划卸货吨位小于23以内的数字");
					return;
				}
				if (data.unloadList[0].lorlEndContact == "" || data.unloadList[0].lorlEndContact == null) {
					proxy.$message.error("请填写收货人");
					return;
				}
				if (data.unloadList[0].lorlEndPhone == "" || data.unloadList[0].lorlEndPhone == null) {
					proxy.$message.error("请填写收货人电话");
					return;
				}

				let params = {
					lorId: data.lorId,
					lorType: "0",
					lorCarrier: "TOP", //承运商ID
					lorCarrierType: "1",
					lorShipper: data.lorShipper, //托运商ID 
					lorShipperType: "0",
					lorSupplier: data.lorSupplier, //供应商ID
					lorSupplierType: "0",
					lorGoods: data.lorGoods,
					lorLoadType: "0",
					lorLoadWhid: data.lorLoadWhid, //装货站点ID
					lorLoadName: data.lorLoadName,
					lorLoadAddr: data.lorLoadAddr,
					lorLoadLnglat: data.lorLoadLnglat,
					lorLoadContact: data.lorLoadContact,
					lorLoadPhone: data.lorLoadPhone,
					lorLoadContact2: data.lorLoadContact2,
					lorLoadPhone2: data.lorLoadPhone2,
					lorLoadRemark: data.lorLoadRemark,
					lorLoadpTime: data.lorLoadpTime,
					lorLoadpWeight: data.lorLoadpWeight,
					lorVehicleId: data.lorVehicleId, //运力车辆
					lorVehHeadId: data.lorVehHeadId,
					lorVehHeadNo: data.lorVehHeadNo,
					lorVehTailId: data.lorVehTailId,
					lorVehTailNo: data.lorVehTailNo,
					lorMdriveId: data.lorMdriveId, //主驾
					lorSdriveId: data.lorSdriveId, //副驾
					lorYayunId: data.lorYayunId, //押运员
					lorRemark: data.lorRemark,
					lorFixedMilage: data.lorFixedMilage, //运费里程
					lorFixedPrice: data.lorFixedPrice, //运费单价
					unloadList: [{
						lorlId: data.unloadList[0].lorlId,
						lorlSort: 1,
						lorlEndWhid: data.unloadList[0].lorlEndWhid, //卸货站点ID
						lorlEndName: data.unloadList[0].lorlEndName,
						lorlEndAddr: data.unloadList[0].lorlEndAddr,
						lorlEndPcode: "450000",
						lorlEndCcode: "451200",
						lorlEndAcode: "451227",
						lorlEndLnglat: data.unloadList[0].lorlEndLnglat,
						lorlEndContact: data.unloadList[0].lorlEndContact,
						lorlEndPhone: data.unloadList[0].lorlEndPhone,
						lorlEndContact2: data.unloadList[0].lorlEndContact2,
						lorlEndPhone2: data.unloadList[0].lorlEndPhone2,
						lorlUnlpTime: data.unloadList[0].lorlUnlpTime,
						lorlUnlpWeight: data.unloadList[0].lorlUnlpWeight,
						lorlUnlRemark: data.unloadList[0].lorlUnlRemark
					}]
				};

				const r = await proxy.$http.post(apiObj.ordUpdate, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isEdit = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};

			//获取所属托运商
			const getProviderTYList = () => {
				let params = {
					page: 1,
					limit: 10000,
					searchWord: "",
					cocOrg: "",
					cocType: 1,
				};
				proxy.$http
					.get(apiObj.cusList, params, {
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						},
					})
					.then((res) => {
						if (res.code == 0) {
							data.ProviderTYList = res.rows;
						}
					});
			};
			//获取所属贸易商
			const getProviderMYList = async () => {
				let params = {
					page: 1,
					limit: 10000,
					searchWord: "",
					cocOrg: "",
					cocType: 2,
				};
				const res = await proxy.$http.get(apiObj.cusList, params);
				console.log(res);
				if (res.code == 0) {
					data.ProviderMYList = res.rows;
				}
			};

			//选择主驾驶员
			const getDirList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.drigetList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.driList = r.driList;
				}
			};
			//选择押运员
			const getYyList = async () => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.yygetList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.yyList = r.yayunList;
				}
			};

			//选择运力车辆
			const getVehicleList = async () => {
				let params = {
					searchWord: "",
					page: 1,
					limit: "10000",
				};
				const r = await proxy.$http.get(apiObj.vehicleList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.vehHeadList = r.rows;
				}
			};


			//选择装货站点
			const getloadSiteList = async (cocId) => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "10000",
					whProviderType: '0',
					whProvider: cocId,
					whType: 'gsloa'
				};
				const r = await proxy.$http.get(apiObj.siteList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.loadsiteList = r.rows;
				}
			};
			//选择卸货站点
			const getunloadSiteList = async (cocId) => {
				let params = {
					searchWord: "",
					offset: "0",
					limit: "10000",
					whProviderType: '0',
					whProvider: cocId,
					whType: 'gsunl'
				};
				const r = await proxy.$http.get(apiObj.siteList, params);
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					data.unloadsiteList = r.rows;
				}
			};
			//改变客商
			const ProviderTYListChange = (value) => {
				const selectedItem = data.ProviderTYList.find(item => item.cocId === value);
				if (selectedItem) {
					getloadSiteList(selectedItem.cocId);
					getunloadSiteList(selectedItem.cocId);
				}
			}
			//选择主驾
			const vehicleMUserChange = (value) => {
				console.log(value);
				const selectedItem = data.driList.find(item => item.driUserId === value);
				if (selectedItem) {
					data.vehicleMUserPhone = selectedItem.driPhone; // 更新其他参数的值。
				} else {
					data.vehicleMUserPhone = null; // 如果没有找到匹配项，则设置为null。
				}
			}
			//选择押运员
			const vehicleYUserChange = (value) => {
				const selectedItem = data.yyList.find(item => item.yyUserId === value);
				if (selectedItem) {
					data.vehicleYUserPhone = selectedItem.yyPhone; // 更新其他参数的值。
				} else {
					data.vehicleYUserPhone = null; // 如果没有找到匹配项，则设置为null。
				}
			}

			const vehicleHeadChange = (value) => {
				const selectedItem = data.vehHeadList.find(item => item.vehicleId === value);
				if (selectedItem) {
					console.log(selectedItem.vehicleHeadId);
					data.lorVehHeadId = selectedItem.vehicleHeadId;
					data.lorVehHeadNo = selectedItem.vehHeadNo;
					data.lorVehTailId = selectedItem.vehicleTailId;
					data.lorVehTailNo = selectedItem.vehTailNo;
					data.lorMdriveId = selectedItem.vehicleMUserid;
					data.lorSdriveId = selectedItem.vehicleSUserid;
					data.lorYayunId = selectedItem.vehicleYUserid;
					data.vehicleMUserPhone = selectedItem.vehMDirPhone;
					data.vehicleYUserPhone = selectedItem.vehYayunPhone;

				} else {
					data.lorVehHeadId = null;
					data.lorVehHeadNo = null;
					data.lorVehTailId = null;
					data.lorVehTailNo = null;
					data.lorMdriveId = null;
					data.lorSdriveId = null;
					data.lorYayunId = null;
					data.vehicleMUserPhone = null;
					data.vehicleYUserPhone = null;
				}
			}

			const siteLoadChange = (value) => {
				const selectedItem = data.siteList.find(item => item.whId === value);
				if (selectedItem) {
					data.lorLoadAddr = selectedItem.whAddr; // 更新其他参数的值。
					data.lorLoadLnglat = selectedItem.whLnglat;
					data.lorLoadName = selectedItem.whName;
				} else {
					data.lorLoadAddr = null; // 如果没有找到匹配项，则设置为null。
					data.lorLoadLnglat = null;
					data.lorLoadName = null;
				}
			}

			const siteUnloadChange = (index, value) => {
				const selectedItem = data.siteList.find(item => item.whId === value);
				if (selectedItem) {
					data.unloadList[index].lorlEndAddr = selectedItem.whAddr; // 更新其他参数的值。
					data.unloadList[index].lorlEndLnglat = selectedItem.whLnglat;
					data.unloadList[index].lorlEndName = selectedItem.whName;
					data.unloadList[index].lorlEndContact = selectedItem.whContact;
					data.unloadList[index].lorlEndPhone = selectedItem.whPhone;
					data.unloadList[index].lorlEndContact2 = selectedItem.whContact2;
					data.unloadList[index].lorlEndPhone2 = selectedItem.whPhone2;
				} else {
					data.unloadList[index].lorlEndAddr = null; // 如果没有找到匹配项，则设置为null。
					data.unloadList[index].lorlEndLnglat = null;
					data.unloadList[index].lorlEndName = null;
					data.unloadList[index].lorlEndContact = "";
					data.unloadList[index].lorlEndPhone = "";
					data.unloadList[index].lorlEndContact2 = "";
					data.unloadList[index].lorlEndPhone2 = "";
				}
			}

			const getlorLoadpTime = (ev) => {
				data.lorLoadpTime = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.lorLoadpTime);
			};

			const getlorlUnlpTime = (index, ev) => {
				data.unloadList[index].lorlUnlpTime = parseTime(ev, "{y}-{m}-{d} {h}:{i}:{s}");
				console.log(data.unloadList[index].lorlUnlpTime);
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				handleAddUploadChange,
				dialogClosedHandle,
				getlorLoadpTime,
				getlorlUnlpTime,
				vehicleMUserChange,
				vehicleYUserChange,
				vehicleHeadChange,
				siteLoadChange,
				siteUnloadChange,
				ProviderTYListChange,
				submit
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 50px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 15px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 150px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 70%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.jzBox {
		border: 1px solid #e6e6e6;
		width: fit-content;
		height: 250px;
		font-size: 14px;
		margin-left: 50px;
		border-top: none;
	}

	.jzWrap .jzBox:nth-child(1) {
		border-top: 1px solid #e6e6e6;
	}

	.jzBoxLeft .jzTitle {
		min-width: 100px;
		text-align: center;
		margin: 0 30px;
		display: block;
	}

	.jzBoxLeft .shu {
		display: block;
		width: 1px;
		height: 20px;
		background: #e1e1e1;
		margin: 0 0px 0 60px;
	}

	.jzBoxRight {
		padding-left: 10px;
		margin-left: 20px;
		height: 200px;
		border-left: 1px solid #e6e6e6;
	}

	.jzBoxRight img {
		margin: 0 10px;
		cursor: pointer;
	}
</style>